import axios, { AxiosRequestConfig } from "axios";
import { getEnvValueFor } from "../helpers/utils";
import { authOperations } from "./features/auth";

export const rmsApi = axios.create({
  baseURL: "",
  responseType: "json",
  headers: {
    "Release-Version": getEnvValueFor("RELEASE_VERSION"),
  },
});

export const authmsApi = axios.create({
  baseURL: getEnvValueFor("AUTH_MS_BASE_URL"),
  responseType: "json",
});

export const fetcher = (url, options = {}) =>
  rmsApi(url, options).then((response) => response.data);

rmsApi.interceptors.response.use(
  (res) => {
    return res;
  },
  (err) => {
    if (err.response && err.response.status === 401) {
      authOperations.setSessionExpired();
    }
    return Promise.reject(err);
  }
);

// Add request interceptor to dynamically set JWT token
rmsApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("jwt");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export type AxiosRequestAction = (param?: any) => {
  payload: { request: AxiosRequestConfig };
};
